import { Box, Container, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Page from '../../components/Page';
import { firestore } from '../../contexts/FirebaseContext';
import { useDispatch, useSelector } from 'react-redux';

import CardListaUsuarios from '../../components/_dashboard/Cards/CardListaUsuarios';
import CardTorta from '../../components/_dashboard/Cards/CardTorta';
import CardGraficoLineas from '../../components/_dashboard/Cards/CardGraficoLineas';
import CardRegistroVentaEmpaques from '../../components/_dashboard/Cards/CardRegistroVentaEmpaques';
import useAuthUsers from '../../hooks/useAuthUsers';
import CardEnviosCorporativo from '../../components/_dashboard/Cards/CardEnviosCorporativo';
import CardListaRegistroServicios from '../../components/_dashboard/Cards/CardListaRegistroServicios';
import CardListaRegistroRecargas from '../../components/_dashboard/Cards/CardListaRegistroRecargas';
import CardListaUsuariosCorporativo from '../../components/_dashboard/Cards/CardListaUsuariosCorporativo';

export default function DashboardCorporativo() {
  const { currentUser } = useAuthUsers();
  const { userList } = useSelector((state) => state.dagpacket);
  const [idsColaboradores, setIdsColaboradores] = useState([]);
  const [envios, setEnvios] = useState([]);
  const [usersCorporativo, setUsersCorporativo] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [selectedUserEnvios, setSelectedUserEnvios] = useState([]);
  const [enviosColaboradores, setEnviosColaboradores] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(currentUser ? currentUser.id : '');

  const handleUserChange = (event) => {
    setSelectedUser(event.target.value);
    setSelectedUserId(event.target.value);
  };

  // trae clientes corporativos

  async function getUsers() {
    const query = firestore.collection('users').where('role', '==', 'cliente-corporativo');

    const unsubscribe = query.onSnapshot((snapshot) => {
      const userList = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setUsersCorporativo(userList);
    });

    return () => unsubscribe();
  }

  // trae los ids de los users del cliente corporativo
  useEffect(() => {
    if (selectedUserId && userList) {
      const filteredIds = userList.filter((user) => user.hostUser === selectedUserId).map((user) => user.id);

      setIdsColaboradores([...filteredIds, selectedUserId]);
    }
  }, [selectedUserId, userList]);

  // filtra los envios con user_id incluido en la lista de ids de colaboradores

  useEffect(() => {
    if (envios && idsColaboradores.length > 0) {
      const enviosColab = envios.filter((envio) => idsColaboradores.includes(envio.user_id));
      setEnviosColaboradores(enviosColab);
    } else {
      setEnviosColaboradores([]);
    }
  }, [envios, idsColaboradores]);

  useEffect(() => {
    if (envios && selectedUserId) {
      const selectedUserEnv = envios.filter((envio) => envio.user_id === selectedUserId);
      setSelectedUserEnvios(selectedUserEnv);
    } else {
      setSelectedUserEnvios([]);
    }
  }, [selectedUserId, envios]);

  useEffect(() => {
    async function getPaqueterias() {
      await firestore
        .collection('cotizaciones')
        // .where('hostUser_id', '==', selectedUser)
        // .where('user_id', '==', currentUser.id)
        .orderBy('created_at', 'desc')
        .onSnapshot((snapshot) => {
          const envios = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
          setEnvios(envios);
        });
    }
    getPaqueterias();
  }, []);

  // trae clientes corporativos solo si es allmighty

  useEffect(() => {
    if (currentUser && currentUser.role === 'almighty') {
      getUsers();
    }
  }, [currentUser]);
  useEffect(() => {
    if (selectedUserId && userList) {
      setIdsColaboradores(userList.filter((user) => user.hostUser === selectedUserId).map((user) => user.id));
    }
  }, [selectedUserId, userList]);

  return (
    <Page title="Paqueterias | Dagpacket">
      {currentUser && currentUser.role === 'almighty' && (
        <FormControl fullWidth variant="outlined" margin="normal" sx={{ maxWidth: 220 }}>
          <InputLabel id="user-corporativo-label">User Corporativo</InputLabel>
          <Select
            labelId="user-corporativo-label"
            id="user-corporativo"
            value={selectedUser}
            onChange={handleUserChange}
            label="User Corporativo"
          >
            {usersCorporativo.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.displayName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}{' '}
      <Grid container spacing={2} padding={1}>
        <Grid item xs={12} sm={6} md={4} flex={1} display="flex">
          <CardEnviosCorporativo envios={[...selectedUserEnvios, ...enviosColaboradores]} title="Mis envíos" />
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4} flex={1} display="flex">
          <CardEnviosCorporativo envios={enviosColaboradores} title="Envíos colaboradores" />
        </Grid> */}
        <Grid item xs={12} sm={6} md={4}>
          <CardRegistroVentaEmpaques />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          {/* se envía current user para pedir los usuarios cuyo hostUser es este */}
          <CardListaUsuariosCorporativo currentUser={selectedUser} />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardListaRegistroServicios />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <CardListaRegistroRecargas />
        </Grid>
      </Grid>
    </Page>
  );
}
